import React from "react";
import "./Button.css";

/**
 * Reusable Button component
 *
 * @param {React.ReactNode} children - The content inside the button (usually text or icons)
 * @param {function} onClick - Click event handler function
 * @param {string} [type="button"] - The HTML button type attribute ("button", "submit", "reset")
 *
 * @returns {JSX.Element} A styled button element
 */
export default function Button({ children, onClick, type = "button" }) {
  return (
    <button
      className="btn"
      type={type}         // Defines button behavior: "button", "submit", or "reset"
      onClick={onClick}   // Event handler triggered on button click
    >
      {children}         {/* Button content: text, icon, or any React node */}
    </button>
  );
}